import React, { useEffect, useState, useContext } from 'react';
import { Table } from 'antd';
import * as Setting from '../utils/AuthUtils';
import AddLeague from '../components/AddLeague';
import { generateLeagueCols } from '../utils/DataUtils';
import { api } from '../AppConfig';
import { MeContext } from '../context';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

function Leagues() {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false)
    const [items, setItems] = useState([]);
    const me = useContext(MeContext);
    const { t } = useTranslation();

    useEffect(() => {
      const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
      setIsAdmin(isAd);
      fetch(api.leagues().list().href)
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            let fltrRes = result.payLoad.filter(function( obj ) {
              return obj.leagueName !== 'LPI';
            });
            setItems(fltrRes);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
      }, [me])
      
      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
        <h1>
            {t('leagues.title')}
        </h1>
        { Setting.isLoggedIn() && isAdmin && 
          <AddLeague />
        }
        <Table
            columns={generateLeagueCols(t)} 
            dataSource={items} 
            pagination={false} 
            loading={!isLoaded}
        />
        </motion.div>
    );
}

export default Leagues;